// ImageMessage.js
import React from 'react'
import Mixpanel from '../../../utils/mixpanel'
import { ANALYTIC_EVENTS } from '../../../utils/constants'
import './ImageMessage.css'
import { isNullOrMissing, moment_type_mapping } from '../../../helpers'

const ImageMessage = ({
  content,
  openModal,
  authorType,
  analyticData,
  message,
  momentType
}) => {
  const cta =
    authorType === 'ME' ? content?.cta_teacher?.[0] : content?.cta?.[0]
  const ctaClickHandler = (e) => {
    Mixpanel.trackEvent({
      event: ANALYTIC_EVENTS.MESSAGE_CTA_CLICKED,
      data: {
        body: content.body,
        redirection: cta?.value,
        ...analyticData
      }
    })
    e.preventDefault()
    openModal(cta?.value)
  }
  const momentTypeMapping = moment_type_mapping?.[momentType]
  const srcUrl =
    authorType === 'ME'
      ? momentTypeMapping?.meSrcUrl
      : momentTypeMapping?.srcUrl

  return (
    <>
      <div className="image-moments-container">
        {!isNullOrMissing(content.media.value) && (
          <>
            <img
              src={content.media.value}
              alt="media"
              className="moments-media-preview"
              onClick={(e) => {
                e.preventDefault()
                // openModal(content.media.value)
              }}
            />
          </>
        )}
        <div>
          <div
            className="moment-type-container"
            style={
              isNullOrMissing(content.media.value) ? { marginTop: 10 } : null
            }>
            {srcUrl && isNullOrMissing(content.media.value) && (
              <img src={srcUrl} className="moment-type-icon" />
            )}
            <div
              style={authorType === 'ME' ? { color: 'white' } : null}
              className="moment-type-label">
              {momentTypeMapping?.label}
            </div>
          </div>
          <p className="cta-body">
            {isNullOrMissing(content?.body)
              ? isNullOrMissing(content.media.value)
                ? ''
                : "Hey, I've shared a new moment!"
              : content.body}
          </p>
        </div>
      </div>

      {cta && cta?.label && cta?.value && (
        <div
          className="cta-container"
          onClick={(e) => {
            // e.preventDefault()
            // openModal(content.media.value)
          }}>
          <a
            href="#"
            className={`cta-button ${authorType === 'ME' ? 'me' : 'not-me'}`}
            onClick={ctaClickHandler}>
            {cta?.label} →
          </a>
        </div>
      )}
    </>
  )
}

export default ImageMessage
